import React, { useState } from 'react';
import { Col, Modal, ModalProps, Row, Typography } from 'antd';

type Props = {
  modalProps?: ModalProps;
  children?: React.ReactElement;
  content: ({ onClose }: { onClose: () => void }) => React.ReactElement;
  footer?: ({ onClose }: { onClose: () => void }) => React.ReactElement;
  title?: string;
  autoOpen?: boolean;
  maskClosable?: boolean;
  setIsModalVisible?: (isModalVisible: boolean) => void;
};

const CustomModal: React.FC<Props> = (props) => {
  const {
    children,
    modalProps,
    content,
    title,
    footer,
    autoOpen = false,
    maskClosable = true,
    setIsModalVisible,
  } = props;
  const [visible, setVisible] = useState(autoOpen);
  let childrenWithClick;
  if (children) {
    childrenWithClick = React.cloneElement(children as React.ReactElement, {
      onClick: () => {
        if (typeof children?.props?.onClick !== 'undefined') {
          children?.props?.onClick.call(window);
        }
        setVisible(true);
        setIsModalVisible && setIsModalVisible(true);
      },
    });
  }

  React.useEffect(() => {
    setVisible(autoOpen);
    setIsModalVisible && setIsModalVisible(autoOpen);
  }, [autoOpen]);

  return (
    <React.Fragment>
      {childrenWithClick && childrenWithClick}
      <Modal
        {...modalProps}
        destroyOnClose
        maskClosable={maskClosable}
        visible={visible}
        onCancel={() => {
          setVisible(false);
          setIsModalVisible && setIsModalVisible(false);
        }}
        centered
        footer={null}
        wrapClassName="custom_modal"
      >
        <Typography.Title level={1}>{title}</Typography.Title>
        {content({
          onClose: () => {
            setVisible(false);
            setIsModalVisible && setIsModalVisible(false);
          },
        })}
        <Row justify="center">
          <Col>
            {footer &&
              footer({
                onClose: () => {
                  setVisible(false);
                  setIsModalVisible && setIsModalVisible(false);
                },
              })}
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default CustomModal;
